<template>
	<div>
		<template v-if="headerShow">
			<div class="headerBox" @mouseenter="mouseover" @mouseleave="mouseout"
				:style="headerHover ? 'background-color:#FFFFFF;' : scrollTop > 100 ? 'background-color:rgba(0,0,0,0.2);' : ''"
				:class="{ 'nav-hidden': navHidden }">
				<div class="headerBox_cen">
					<div class="headerBox_img" @click="goIndex">
						<template v-if="logo2 && logo1">
							<img :src="logo2" v-if="headerHover" />
							<img :src="logo1" v-else />
						</template>
					</div>
					<div class="headerBox_li" :class="headerHover ? 'headerBox_list_two' : 'headerBox_list'">
						<ul>
							<template v-for="(item, index) in list">
								<li :class="current == item.value ? 'xz' : 'wxz'" @mouseenter="mouseoverLi(index)"
									@mouseleave="mouseoutLi(index)">
									<!--  -->
									<div class="top">
										<div @click="goPath(item)" class="top_til">
											{{ item.name }}
										</div>
										<div v-if="item.show && item.children && !findChildren(item.children) && !navHidden"
											class="dw" :ref="`dw${index}`">
											<ul>
												<li @mouseenter="mouseoverLiTwo(indexa)"
													@mouseleave="mouseoutLiTwo(indexa)"
													v-for="(itema, indexa) in item.children" :key="indexa"
													:style="childXz == indexa ? 'color:#000;' : ''"
													@click.stop="goPathTo(itema)">
													{{ itema.name }}
												</li>
											</ul>
											<div class="bj" :style="{ height: bjHeight + 'px' }"></div>
										</div>
										<div v-else-if="item.show && item.children && findChildren(item.children) && !navHidden"
											:ref="`dw${index}`" class="dw bigdw">
											<div class="navBarOne">
												<div @click.stop="goPathTo(item2)" :name="item2.name" class="navBarOneItem"
													v-for="(item2, index2) in item.children" :key="item2.id">
													<div class="oneName">{{ item2.name }}</div>
													<div class="navBarTwo">
														<div class="navBarTwoItem"
															@click.stop="goChildPath(item3, index2)"
															v-for="item3 in item2.children">
															{{ item3.name }}
														</div>
													</div>
												</div>
											</div>
											<div class="bj" :style="{ height: bjHeight + 'px' }"></div>
										</div>
									</div>
								</li>
							</template>

						</ul>
					</div>
					<!-- <div class="headerBox_ss">
					<img src="@/assets/header/ss.png" v-if="headerHover" />
				</div> -->
					<div :class="headerHover ? 'headerBox_lang_two' : 'headerBox_lang'">
						<div class="lang" @mouseenter="mouseoverLang()" @mouseleave="mouseoutLang()">
							<div class="langTil">
								<span v-if="locale === 'en'" class="wz"
									:style="headerHover ? 'color: #000;' : ''">EN</span>
								<span v-if="locale === 'zh'" class="wz"
									:style="headerHover ? 'color: #000;' : ''">中文</span>
								<img src="@/assets/header/jtTwo.png" v-if="langShow == false" class="img" />
								<img src="@/assets/header/jtThree.png" v-else-if="langShow" class="img" />
								<img src="@/assets/header/jt.png" v-else class="img" />
								<div :class="headerHover ? 'headerBox_user_two' : 'headerBox_user'">
									<template v-if="userName">
										<span class="user-name" :title="displayUserName">{{ displayUserName }}</span>
											<span class="user-divider">|</span>
										<a href="javascript:;" @click="logout">{{ $t('account.logout') }}</a>
									</template>
								<router-link v-else :to="'/login'">{{ $t('account.loginRegister') }}</router-link>
							</div>
							</div>
							<!-- v-if="langShow&&!navHidden" -->
							<div class="langdw" v-if="langShow && !navHidden">
								<ul>
									<!-- :style="locale === 'en'?'color: #000;':'color: #686868;'" -->
									<li @click="changeLanguage('en')">EN</li>
									<!-- :style="locale === 'zh'?'color: #000;':'color: #686868;'" -->
									<li @click="changeLanguage('zh')">
										中文
									</li>
								</ul>
							</div>
						</div>

					</div>
				</div>
				<div class="headerXian" v-if="headerHover && !navHidden && xianShow"></div>
			</div>
		</template>
		<!-- :class="{ 'nav-hidden': navHidden }" -->
		<div class="h5Head" v-else :class="{ 'nav-hidden': navHidden }">
			<div class="h5HeadBox_img" @click="goIndex">
				<img :src="logo2" />
			</div>
			<div @click="h5Tab = true">
				<i class="el-icon-s-unfold" style="font-size: 28px;"></i>
			</div>
		</div>
		<el-drawer title="" :visible.sync="h5Tab" :before-close="handleClose" direction='ltr' :append-to-body="true"
			size="50%">
			<div class="h5DrawerTop">
				<div class="h5DrawerLogin">
					<template v-if="userName">
						<span class="h5UserName" :title="displayUserName">{{ displayUserName }}</span>
						<span class="h5UserLine">|</span>
						<a href="javascript:;" @click="h5Tab = false; logout()">{{ $t('account.logout') }}</a>
					</template>
					<router-link v-else :to="'/login'" @click.native="h5Tab = false">{{ $t('account.loginRegister') }}</router-link>
				</div>
				<div class="h5DrawerLang">
					<span v-if="locale === 'zh'" @click="h5Tab = false; changeLanguage('en')">English</span>
					<span v-else @click="h5Tab = false; changeLanguage('zh')">中文</span>
				</div>
			</div>
			<el-menu class="el-menu-vertical-demo">
				<template v-for="(item, index) in list">
					<template v-if="item.childe">
						<el-submenu :index="index + ''">
							<template slot="title">
								<span slot="title">{{ item.name }}</span>
							</template>
							<el-menu-item-group v-for="(itema, indexa) in item.children">
								<el-menu-item :index="index + '-' + indexa" @click="goPathTo(itema)">{{ itema.name
									}}</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
					</template>
					<template v-else>
						<el-menu-item :index="index + ''" @click="goPath(item)">
							<span slot="title">{{ item.name }}</span>
						</el-menu-item>
					</template>
				</template>
			</el-menu>
		</el-drawer>
		<el-backtop :bottom='70'></el-backtop>
		<el-backtop ref="backOne" :bottom="40" :visibility-height="0" @click="goBack" v-if="!isTabShow">
			<div>
				<i class="el-icon-arrow-left" style="font-size: 28px;"></i>
			</div>
		</el-backtop>
	</div>
</template>

<script>
import {
	get_config,
	get_nav_list,
} from "@/api/config.js"
export default {
	components: {},
	props: {
		current: {
			typeof: String,
			default: 'souye'
		}
	},
	data() {
		return {
			list: [],
			// list: [{
			// 	name: this.$t('首页'),
			// 	value: 'souye',
			// 	path: '/'
			// },
			// {
			// 	name: this.$t('产品'),
			// 	value: "product",
			// 	show: false,
			// 	path: '/product',
			// },
			// {
			// 	name: this.$t('临床案例'),
			// 	value: "Cases",
			// 	path: '/cases'
			// },
			// {
			// 	name: this.$t('合作伙伴'),
			// 	value: "Partners",
			// 	show: false,
			// 	path: '',
			// 	children: [{
			// 		name: this.$t('故事'),
			// 		value: '',
			// 		path: 'partners',
			// 	},
			// 	]
			// },
			// {
			// 	name: this.$t('新闻'),
			// 	value: "",
			// 	show: false,
			// 	path: '',
			// 	children: [{
			// 		name: this.$t('展览'),
			// 		value: '',
			// 		path: 'newsExhibitions',
			// 	},
			// 	{
			// 		name: this.$t('产品'),
			// 		value: '',
			// 		path: 'newsProducts',
			// 	}]
			// },
			// {
			// 	name: this.$t('公司'),
			// 	value: "company",
			// 	show: false,
			// 	path: '/company',
			// },
			// {
			// 	name: this.$t('联系'),
			// 	value: "contactUs",
			// 	show: false,
			// 	path: '/contact',
			// }],
			navList: [],
			showNavList: [],
			locale: 'zh',
			headerHover: false,
			childXz: 0,
			langShow: false,
			headerTrue: false,
		scrollTop: 0,
		navHidden: false,
		lastScrollTop: 0,
			// logo1: "",
			// logo2: '',
			bjHeight: "",
			xianShow: false,
			navHead: false,
			h5Tab: false,
			isTabShow: true,
			logo1: require('@/assets/index/logo.png'),
			logo2: require('@/assets/index/logo.png'),
		}
	},
	created() {
		this.getNavListData()
	},

	computed: {
			userName() {
				return this.$store.state.userName
			},
			displayUserName() {
				return this.$store.state.userRealName || this.$store.state.userName
			},
			langPrefix() {
				const l = localStorage.getItem('i18n-lang') || 'zh'
				return l == 'zh' ? '/cn' : '/en'
			}
	},

	mounted() {
		let t = this;
		// 窗口小于1200隐藏导航栏
		// window.screen.width
		// window.innerWidth
		this.goSetHeader();
		console.log(this.headerShow)
		this.locale = this.$i18n.locale;
		console.log(this.$i18n.locale)
		window.addEventListener('scroll', this.handleScroll);
		// this.getConfigList();

		if (this.locale != 'zh') {
			// delete this.list[1].childe
			// this.list[1].childe.splice(1,1)
		}
		let aaheadHover = localStorage.getItem("headerHover") || false;
		if (!aaheadHover) {
			try {
				localStorage.removeItem('headerHover')
			} catch (e) {
				//TODO handle the exception
			}
		}
		this.navHead = aaheadHover;
		if (!this.headerShow) {
			let rout = location.pathname;
			if (rout == '/en' || rout == '/cn' || rout == '/') {
				this.isTabShow = true;
			} else {
				let routTwo = rout.split('/');
				let routThree = '/' + routTwo[routTwo.length - 1];
				let arrTwo = ['/about', '/abInvest', '/news', '/product', '/innovation', '/recruitSociety', '/recruitCampus', '/contact'];
				console.log(routThree, arrTwo.includes(routThree), 'aaaaaaaaaaaaaaaaaaaaaaaaaaa')
				if (arrTwo.includes(routThree)) {
					this.isTabShow = true;
				} else {
					this.isTabShow = false;
					this.$nextTick(function () {
						this.$refs.backOne.visible = true;
					})
				}
			}
		} else {
			this.isTabShow = true;
		}
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	watch: {
		navHidden() {
			this.list.map(v => {
				v.show = false
			})
		},
		scrollTop(newa, old) {
			// if(old>newa&&newa==0){
			// 	let t=this;
			// 	let aaheadHover=localStorage.getItem("headerHover")||false;
			// 	if(!aaheadHover){
			// 		localStorage.removeItem('headerHover')
			// 	}
			// 	t.headerHover=aaheadHover
			// }
		}
	},
	methods: {
		goBack() {
			window.history.go(-1);
		},
		handleClose() {
			this.h5Tab = false
		},
		// 监听页面滚动
		handleScroll(e) {
			var element;
			if (this.nowVibe == 'pc') {
				element = document.documentElement
			} else {
				element = document.documentElement.scrollTop ? document.documentElement : document.body;
			}
			const currentScrollTop = element.scrollTop;
			this.scrollTop = currentScrollTop;
			// 顶部附近(含移动端回弹/惯性超出)强制显示，避免滑动到最上端时闪烁消失
			if (currentScrollTop <= 5) {
				this.navHidden = false;
			} else if (currentScrollTop > this.lastScrollTop + 5) {
				// 向下滚动隐藏
				this.navHidden = true;
			} else if (currentScrollTop < this.lastScrollTop - 5) {
				// 向上滚动显示
				this.navHidden = false;
			}
			this.lastScrollTop = currentScrollTop;
		},
		// 顶部移入
		mouseover() {
			this.navHead = true;
			if (this.headerTrue) {
				return
			}
			this.headerHover = true;
		},
		mouseout() {
			this.navHead = false;
			if (this.headerTrue) {
				return
			}
			this.headerHover = false;
		},
		// 一级菜单移入
		mouseoverLi(e) {
			this.headerHover = true;
			this.list[e].show = true;
			this.xianShow = true;
			this.$nextTick(() => {
				try {
					this.bjHeight = this.$refs['dw' + e][0].offsetHeight
				} catch (e) {
					//TODO handle the exception
				}
			})
			// if(this.locale=='en'){
			// 	this.$nextTick(()=>{
			// 		try{
			// 			this.bjHeight=this.$refs['dw'+e][0].offsetHeight
			// 		}catch(e){
			// 			//TODO handle the exception
			// 		}
			// 	})
			// }
		},
		mouseoutLi(e) {
			this.xianShow = false;
			this.list[e].show = false;
		},
		// 二级菜单移入
		mouseoverLiTwo(e) {
			this.childXz = e;
		},
		mouseoutLiTwo(e) {
			this.childXz = 0;
		},
		// 语言移入
		mouseoverLang() {
			this.xianShow = true;
			this.langShow = true;
		},
		mouseoutLang() {
			this.xianShow = false;
			this.langShow = false;
		},
		/* 切换语言 */
		changeLanguage(lang) {
			this.langShow = false;
			this.$i18n.locale = lang;
			this.locale = this.$i18n.locale;
			localStorage.setItem("i18n-lang", lang);

			if (lang == 'zh') {
				document.title = '澳华内镜';
				this.$router.push('/cn')
			} else {
				document.title = 'Aohua Endoscopy';
				this.$router.push('/' + lang)
			}
			return;
			let str1 = this.$route.fullPath;
			let str2 = '';
			if (str1.includes('cn')) {
				str2 = str1.replace('cn', lang);
			} else {
				str2 = str1.replace('en', lang);
			}
			if (this.locale !== 'zh' && this.$route.path == '/recruit') {
				this.$router.push('/null')
			} else if (str2) {
				window.location.href = str2
			} else {
				window.location.reload()
			}
		},
		// 用户点击菜单栏
		goPath(item) {
			let t = this;
			console.log(item.path)
			if (!item.path) {
				if(item.children){
					this.goPathTo(item.children[0])
				}
				return
			}
			if (t.$route.path != item.path) {
				if (item.path == '/') {
					if (this.locale == 'zh') {
						t.$router.push('/cn')
					} else {
						t.$router.push('/en')
					}
				} else {
					let lang = this.locale == 'zh' ? 'cn' : 'en'
					t.$router.push('/' + lang + item.path)
				}
			}
		},
		// 用户点击菜单栏
		goPathTo(item) {
			// console.error(item)
			let t = this;
			if (!item.path) {
				return
			}
			let lang = this.locale == 'zh' ? 'cn' : 'en'
			let path = '/' + lang + item.path
			let path2 = path.split('?')[0]
			console.log(path, t.$route.path)
			if (t.$route.path != path2) {
				t.$router.push({
					path: path,
					query: {
						value: item.value
					}
				})
			} else {
				t.$router.replace({
					path: path,
					query: {
						value: item.value
					}
				})
				this.$router.go(0)
			}
		},
		getConfigList() {
			let data = {};
			get_config(data).then(res => {
				console.log(res)
				this.logo1 = res.data.site_logo;
				this.logo2 = res.data.site_logo_select;
			}).catch(err => {
				console.log(err)
			})
		},
		goIndex() {
			let t = this;
			var element;
			if (this.nowVibe == 'pc') {
				element = document.documentElement
			} else {
				element = document.documentElement.scrollTop ? document.documentElement : document.body;
			}
			if (t.$route.path == '/en' || t.$route.path == '/cn') {
				element.scrollTop = 0
				return
			}
			if (t.$route.path != '/') {
				if (this.locale == 'zh') {
					t.$router.push('/cn')
				} else {
					t.$router.push('/en')
				}
			} else {
				element.scrollTop = 0
			}
		},

		getNavListData() {
			get_nav_list().then(res => {
				const dfsRecursive = (node, list) => {
					console.log(node.id)
					if (node.children && node.children.length > 0) {
						node.children.forEach(child => {
							// console.error(list)
							list.push({ name: child.name, path: child.path })
							return dfsRecursive(child, list)
						})
					}
				}
				this.showNavList = res.data
				this.list = res.data
			})
		},
		findChildren(arr) {
			let list = arr.filter(el => el.children)
			if (list.length) {
				return true
			} else {
				return false
			}
		},
		goChildPath(data, index) {
			if (!data.path) {
				return
			}
			let lang = this.locale == 'zh' ? 'cn' : 'en'
			let path = '/' + lang + data.path
			let path2 = path.split('?')[0]
			if (data.path == '/cases') {
				let query = {}
				if (index == 0) {
					query.type1 = data.id
				} else {
					query.type2 = data.id
				}
				if (path2 != this.$route.path) {
					this.$router.push({
						path,
						query,
					})
				} else {
					this.$router.replace({
						path,
						query,
					})
					this.$router.go(0)
				}

			} else {
				if (path2 != this.$route.path) {
					this.$router.push({
						path,
					})
				} else {
					this.$router.replace({
						path,
					})
					this.$router.go(0)
				}
			}
		},
		logout() {
				localStorage.removeItem('user_token')
				localStorage.removeItem('user_id')
				localStorage.removeItem('user_name')
				localStorage.removeItem('user_real_name')
				this.$store.commit('setUserName', false)
				this.$store.commit('setUserRealName', false)
				this.$router.push(this.langPrefix)
			},
	}
}
</script>

<style></style>
<style scoped lang="scss">
// .headerBox:hover{
// 	background-color:#FFFFFF;
// 	border: 1px solid #DADADA;
// }
.nav-hidden {
	top: -100px !important;
}

.headerXian {
	position: fixed;
	border-top: 1px solid #DADADA;
	top: 56px;
	left: 0;
	width: 100%;
	height: 0px;
	// background-color: #DADADA;
	z-index: 3;
}

.headerBox {
	transition: all .5s ease-out;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 999;
	border: 1px solid #DADADA;
	background-color: #ffffff;

	&:hover {
		background-color: #FFFFFF;
		border: 1px solid #DADADA;
	}

	.headerBox_cen {
		width: 1200px;
		// height: 56px;
		margin: 0 auto;
		display: flex;

		// align-items: center;
		.headerBox_img {
			width: 110px;
			height: 56px;
			margin-right: 153px;
			display: flex;
			align-items: center;
			cursor: pointer;

			img {
				width: 110px;
				height: 19px;
			}
		}

		.headerBox_li {
			flex: 1;

			>ul {
				list-style: none;
				display: flex;
				padding: 0;
				margin: 0;
				position: relative;
				z-index: 9;

				>li:not(:last-child) {
					padding-right: 33px;
				}

				>li {
					font-size: 16px;
					display: flex;
					font-weight: 400;
					cursor: pointer;
					position: relative;
					z-index: 9;

					.top {
						.top_til {
							line-height: 56px;
							position: relative;

							&:before {
								content: "";
								position: absolute;
								left: 50%;
								bottom: 0px;
								height: 2px;
								width: 0;
								background-color: #000;
								transition: all 0.3s ease-in-out;
								transform: translateX(-50%);
							}
						}
					}

					.dw {
						min-width: 100%;
						z-index: 2;
						position: absolute;
						z-index: 9;
						padding-bottom: 30px;
						padding-top: 20px;

						>ul {
							position: relative;
							z-index: 99;
							list-style: none;
							width: 100%;
							padding: 0;

							>li:not(:last-child) {
								padding-bottom: 20px;
							}

							>li {
								color: #000000;
								font-size: 16px;

								font-weight: 300;
								width: 100%;
								white-space: nowrap;

								&:hover {
									font-weight: bold;
									color: #000;
								}
							}

						}
					}

					.bj {
						position: fixed;
						top: 57px;
						left: 0;
						width: 100%;
						height: 0px;
						z-index: -1;
						background-color: #fff;
					}

					&:hover .top_til::before {
						width: 100%;
						// display: none;
					}
				}

			}
		}

		.headerBox_list {
			flex: 1;

			>ul {
				>li {
					// color: #FFFFFF;
					color: #000000;
				}
			}
		}

		.headerBox_list_two {
			>ul {
				>li {
					color: #000;
				}

			}

		}

		.headerBox_ss {
			flex: 1;
			width: 17px;

			img {
				width: 17px;
				height: 17px;
			}
		}
	}

	.lang {
		position: relative;
		// width: 145px;
		cursor: pointer;

		.langTil {
			position: relative;
			min-width: 80px;
			height: 56px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			&:before {
				content: "";
				position: absolute;
				left: 50%;
				bottom: -2px;
				height: 4px;
				width: 0;
				background-color: #000;
				transition: all 0.3s ease-in-out;
				transform: translateX(-50%);
				opacity: 0;
			}
		}

		&:hover .langTil::before {
			width: 100%;
		}

		.langdw {
			font-size: 16px;
			min-width: 100%;
			z-index: 2;
			padding-bottom: 30px;

			>ul {
				border: none;
				list-style: none;
				width: 100%;
				padding: 0;

				// background-color: #fff;
				>li:first-child {
					padding-top: 20px;
					margin-top: -4px;
				}

				>li:not(:last-child) {
					padding-bottom: 30px;
				}

				>li {
					color: #000000;
					font-size: 16px;
					font-weight: 500;
					width: 100%;
					cursor: pointer;

					&:hover {
						font-weight: bold;
						color: #000;
					}
				}
			}
		}

		.wz {
			font-size: 16px;

			font-weight: 400;
			color: #000000;
		}

		.img {
			width: 14px;
			height: 8px;
			margin-left: 11px;
		}
	}
}

// 根据html lang 属性值进行样式修改
[lang]:lang(en) {
	.headerBox {
		.top {
			.top_til {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.dw {
				position: absolute;
				z-index: 9;

				ul {
					position: relative;
					z-index: 99;

					li {
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}

				.bj {
					position: fixed;
					top: 57px;
					left: 0;
					width: 100%;
					height: 0px;
					z-index: -1;
					background-color: #fff;
				}
			}
		}

	}
}

.bigdw {
	width: 10000%;
	z-index: 99;

	.navBarOne {
		width: 100%;
		display: flex;

		.navBarOneItem {
			padding-right: 60px;
			// min-width: 60px;

			&::after {
        	display: block;
        	content: attr(name);
        	font-weight: bold;
        	visibility: hidden;
        	height: 1px;
        	color: transparent;
        	margin-bottom: -1px;
        	overflow: hidden;
      		}

			.oneName {
				font-size: 16px;

				&:hover{
					font-weight: bold;
				}
			}

			.navBarTwo {
				padding-top: 12px;

				.navBarTwoItem {
					font-size: 14px;
					color: #010101;
					font-weight: 300;
					padding: 12px 0;
					min-width: 110px;

					&:hover {
						font-weight: bold;
					}
				}
			}
		}
	}
}

.headerBox_lang,
.headerBox_lang_two {
	display: flex;
	align-items: center;
	margin-left: auto;
	gap: 0;
}

.headerBox_user {
	display: flex;
	align-items: center;
	margin-left: 20px;
	font-size: 14px;
	white-space: nowrap;
}
.headerBox_user a {
	color: #000000;
	text-decoration: none;
}
.headerBox_user_two {
	display: flex;
	align-items: center;
	margin-left: 20px;
	font-size: 14px;
	white-space: nowrap;
}
.headerBox_user_two a {
	color: #000000;
	text-decoration: none;
}
.user-name {
	display: inline-block;
	max-width: 140px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: #000000;
	font-weight: 400;
}
.user-divider {
	margin: 0 10px;
	color: #DCDCDC;
}

@media screen and (max-width:1200px) {
	.h5Head {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		z-index: 99999;
		display: flex;
		background-color: #FFFFFF;
		justify-content: space-between;
		align-items: center;
		padding: 0 30px;
		box-sizing: border-box;

		.h5HeadBox_img {
			width: 179px;
			height: 56px;
			display: flex;
			align-items: center;
			cursor: pointer;

			img {
				// width: 175px;
				height: 22px;
				object-fit: contain;
			}
		}
	}

	.el-drawer__wrapper {
		width: 100vw;
	}

	.h5DrawerTop {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px 20px;
		border-bottom: 1px solid #EEEEEE;

		.h5DrawerLogin {
			display: flex;
			align-items: center;
			font-size: 15px;
			white-space: nowrap;

			a {
				color: #000000;
				text-decoration: none;
			}

			.h5UserName {
				max-width: 90px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				color: #000000;
			}

			.h5UserLine {
				margin: 0 8px;
				color: #DCDCDC;
			}
		}

		.h5DrawerLang {
			display: flex;
			align-items: center;
			font-size: 14px;
			color: #666666;

			span {
				cursor: pointer;
			}

			.h5LangXz {
				color: #0080FF;
				font-weight: 600;
			}

			.h5LangGap {
				margin: 0 6px;
				color: #CCCCCC;
			}
		}
	}
}
</style>
